
import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import NavLinks from './navbar/NavLinks';
import UserControls from './navbar/UserControls';
import MobileNavMenu from './navbar/MobileNavMenu';

const Navbar = () => {
  const location = useLocation();
  const [isLoginOpen, setIsLoginOpen] = useState(false);
  
  const isMedsPage = location.pathname === '/meds';

  return (
    <header className="sticky top-0 z-50 w-full border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="container flex h-16 items-center justify-between">
        <div className="flex items-center">
          <Link to="/meds" className="font-bold text-lg">Grand Avenue Pharmacy</Link>
          <NavLinks currentPath={location.pathname} />
        </div>

        <div className="flex items-center gap-2">
          <UserControls 
            isMedsPage={isMedsPage} 
            isLoginOpen={isLoginOpen} 
            setIsLoginOpen={setIsLoginOpen} 
          />
          
          <MobileNavMenu 
            currentPath={location.pathname} 
            onLoginClick={() => setIsLoginOpen(true)} 
          />
        </div>
      </div>
    </header>
  );
};

export default Navbar;
